// portfolio-optimizer/src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";

// i18n 초기화 & React-i18next Provider
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

// 환경변수에서 읽어오기: .env.development/.env.production
const REDIRECT_URI = process.env.REACT_APP_AUTH_REDIRECT_URI;
const POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_AUTH_POST_LOGOUT_REDIRECT_URI;

// Cognito Hosted UI의 도메인 (자주 “{랜덤문자}.auth.ap-northeast-2.amazoncognito.com” 꼴)
const cognitoDomain = "https://ap-northeast-24muh9hzah.auth.ap-northeast-2.amazoncognito.com";
const clientId = "kcnm1ls4p2io3e25dea5b7u48";

const cognitoAuthConfig = {
  authority: cognitoDomain,                    // Hosted UI 기본 도메인
  client_id: clientId,                         // Cognito App Client ID
  redirect_uri: REDIRECT_URI,                  // 로그인 완료 후 돌아올 주소
  response_type: "code",                       // Authorization Code + PKCE
  scope: [
    "openid",
    "profile",
    "email",
    "https://api.quanport.net/portfolios.read",
    "https://api.quanport.net/portfolios.write"
  ].join(" "),
  post_logout_redirect_uri: POST_LOGOUT_REDIRECT_URI, // 로그아웃 후 돌아올 주소

  // 자동 토큰 갱신, 리프레시 토큰 사용 등
  loadUserInfo: true,              // userinfo 엔드포인트 호출
  automaticSilentRenew: true,      // 토큰 만료 직전에 silent renew
  silent_redirect_uri: `${window.location.origin}/silent-renew`, 
  useRefreshTokens: true,          // 리프레시 토큰 활성화

  metadata: {
    authorization_endpoint: `${cognitoDomain}/oauth2/authorize`,
    token_endpoint:         `${cognitoDomain}/oauth2/token`,
    userinfo_endpoint:      `${cognitoDomain}/oauth2/userInfo`,
    end_session_endpoint:   `${cognitoDomain}/logout`
      + `?client_id=${clientId}`
      + `&logout_uri=${encodeURIComponent(POST_LOGOUT_REDIRECT_URI)}`,
  },

  // ✅ 2. 아래 설정을 추가하여 LocalStorage를 사용하도록 변경합니다.
  userStore: new WebStorageStateStore({ store: window.localStorage }),

};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <AuthProvider {...cognitoAuthConfig}>
        <App />
      </AuthProvider>
    </I18nextProvider>
  </React.StrictMode>
);

reportWebVitals();